var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTraingleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.498 15.7639L12.498 1.7639C12.3236 1.4561 12.0706 1.20008 11.7649 1.02197C11.4592 0.843846 11.1118 0.75 10.758 0.75C10.4042 0.75 10.0568 0.843846 9.75107 1.02197C9.44539 1.20008 9.19243 1.4561 9.018 1.7639L1.018 15.7639C0.841678 16.0693 0.749224 16.4158 0.750005 16.7684C0.750786 17.121 0.844774 17.4671 1.02244 17.7717C1.20011 18.0763 1.45514 18.3285 1.76169 18.5027C2.06824 18.677 2.4154 18.7671 2.768 18.7639H18.768C19.1189 18.7635 19.4635 18.6709 19.7673 18.4952C20.071 18.3195 20.3232 18.067 20.4985 17.763C20.6738 17.459 20.766 17.1143 20.7659 16.7634C20.7659 16.4125 20.6734 16.0678 20.498 15.7639Z",
    fill: "#FFF8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.768 6.7639V10.7639V6.7639Z",
    fill: "#FFF8E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.768 14.7639H10.778H10.768Z",
    fill: "#FFF8E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.768 6.7639V10.7639M10.768 14.7639H10.778M20.498 15.7639L12.498 1.7639C12.3236 1.4561 12.0706 1.20008 11.7649 1.02197C11.4592 0.843846 11.1118 0.75 10.758 0.75C10.4042 0.75 10.0568 0.843846 9.75107 1.02197C9.44539 1.20008 9.19243 1.4561 9.018 1.7639L1.018 15.7639C0.841678 16.0693 0.749224 16.4158 0.750005 16.7684C0.750786 17.121 0.844774 17.4671 1.02244 17.7717C1.20011 18.0763 1.45514 18.3285 1.76169 18.5027C2.06824 18.677 2.4154 18.7671 2.768 18.7639H18.768C19.1189 18.7635 19.4635 18.6709 19.7673 18.4952C20.071 18.3195 20.3232 18.067 20.4985 17.763C20.6738 17.459 20.766 17.1143 20.7659 16.7634C20.7659 16.4125 20.6734 16.0678 20.498 15.7639Z",
    stroke: "#8A5C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTraingleIcon);
export default __webpack_public_path__ + "static/media/WarningTraingleIcon.3b0a14f41318a127b6d8e0e1010103d1.svg";
export { ForwardRef as ReactComponent };